import { render, staticRenderFns } from "./CompaniesResources.vue?vue&type=template&id=c30aee2a"
import script from "./CompaniesResources.vue?vue&type=script&lang=js"
export * from "./CompaniesResources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports